(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["medpat-cable-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('medpat-cable-offer')) {
  customElements.define('medpat-cable-offer', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.button = this.querySelector('[data-add-bundle]');
      this.select = this.querySelector('[data-cable-variant]');
      this.status = this.querySelector('[data-offer-status]');
      this.variants = JSON.parse(this.querySelector('[data-phone-variants]').textContent);
      this.select.addEventListener('change', () => {
        const option = this.select.selectedOptions[0];
        this.querySelector('[data-offer-price]').textContent = option.dataset.offer;
        this.querySelector('[data-regular-price]').textContent = option.dataset.price;
      });
      this.button.addEventListener('click', event => this.addBundle(event));
    }
    async addBundle(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.button.disabled) return;
      this.status.textContent = '';
      const form = this.closest('form');
      const phoneInput = form?.querySelector('[data-bstr-variant-input]');
      const phoneButton = form?.querySelector('[data-buy-button]');
      const phoneId = Number(phoneInput?.value);
      const phone = this.variants.find(variant => variant.id === phoneId && variant.available);
      if (!phone || !phoneButton || phoneButton.disabled) {
        this.status.textContent = this.dataset.selectError;
        form?.querySelector('.product__swatches')?.scrollIntoView({block:'center', behavior:'smooth'});
        return;
      }
      const quantityInput = form.querySelector('[name="quantity"]');
      const quantity = quantityInput ? Number(quantityInput.value) : 1;
      if (!Number.isInteger(quantity) || quantity < 1 || (quantityInput && !quantityInput.reportValidity())) return;
      const option = this.select.selectedOptions[0];
      if (!option || option.disabled) return;
      const phoneItem = { id: phoneId, quantity };
      const properties = {};
      for (const [key, value] of new FormData(form)) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && typeof value === 'string') properties[match[1]] = value;
      }
      if (Object.keys(properties).length) phoneItem.properties = properties;
      const originalLabel = this.button.textContent;
      this.button.disabled = true;
      this.button.textContent = this.dataset.loading;
      this.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(this.dataset.addUrl, {
          method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json', 'Accept':'application/json'},
          body:JSON.stringify({items:[phoneItem, {id:Number(option.value), quantity}]})
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(result.description || this.dataset.cartError);
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        this.status.textContent = error.message || this.dataset.cartError;
        this.button.disabled = false;
        this.button.textContent = originalLabel;
        this.removeAttribute('aria-busy');
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["medpat-phone-swatches"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('medpat-phone-colors')) {
  customElements.define('medpat-phone-colors', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      const sync = () => this.querySelectorAll('[data-swatch-option]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.classList.contains('swatch--active')));
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-swatch-option]');
        if (!button || !this.contains(button)) return;
        event.preventDefault();
        if (button.classList.contains('swatch--active')) event.stopImmediatePropagation();
      }, true);
      this.observer = new MutationObserver(sync);
      this.observer.observe(this, {subtree:true, attributes:true, attributeFilter:['class']});
      sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
